module.exports = __webpack_public_path__ + "img/COMP.68140f66.svg";